import request from '../_helpers/request';

export const adminService = {
    GetSupplierList,
    GetSupplierList_FilterBasicData,
    GetSupplierList_Ads,
    GetCompanyApprovalList,
    GetSupplierList_AdsBasicData,
    SendForgetPasswordByAdmin,
    ResetAccountPassword,
    SubmitReminderEmail,
    SubmitReminderEmailAll,
    SendAccountPasswordEmail,
    GetBlacklist,
    AddBlacklist,
    DeleteBlacklist,
    GetMembershipByEmail,
    InsertAiCompanyResearchQueue,
    SubmitAiResearchPreview,
    GetRejectReasons,
    GetRejectTemplatesByApprovalId,
    GetRejectReasonByApprovalId,
    GetAllSysStatusByType,
};

function GetSupplierList(filter, SortColumns, SortDirections, PageNumber, PageSize, SalesCode, EBoothFilter) {
    var url = "Admin/GetSupplierList";

    var params = {
        "filter": filter
        , "SortColumns": SortColumns
        , "SortDirections": SortDirections
        , "PageNumber": PageNumber
        , "PageSize": PageSize
        , "SalesCode": SalesCode || "All"
        , "EBoothFilter": EBoothFilter || "All"
        , "action": {
            "LangId": localStorage.getItem("currentLangId")
            , "IP": window.location.host
            , "URL": window.location.href
            , "Referral": document.referrer
            , "BAgent": window.navigator.userAgent

        }
    };
    return request.post(url, params)
        .then(res => {
            if (res.data) {
                return res.data;
            } else {
                return res.systemErrorMsg;
            }
        })

}

function GetSupplierList_FilterBasicData() {
    var url = "Admin/GetSupplierList_FilterBasicData";
    return request.post(url, { "action": {
            "LangId": localStorage.getItem("currentLangId")
            , "IP": window.location.host
            , "URL": window.location.href
            , "Referral": document.referrer
            , "BAgent": window.navigator.userAgent
        }})
        .then(res => {
            if (res && res.isSuccessful && res.data) {
                return res.data;
            }
            if (res && res.data) {
                return res.data;
            }
            return res.systemErrorMsg || res;
        });
}

function GetSupplierList_Ads(searchText,fitercolunms, sortColumns,  pageNumber, pageSize) {
    var url = "Admin/GetSupplierList_Ads";

    var params = {
        "SearchText": searchText,
        "Fitercolunms": fitercolunms
        , "SortColumns": sortColumns 
        , "PageNumber": pageNumber
        , "PageSize": pageSize 
        ,"LangId":localStorage.getItem("currentLangId")
    };
    return request.post(url, params)
        .then(res => {
            if (res.data) {
                return res.data;
            } else {
                return res.systemErrorMsg;
            }
        })

}
function GetCompanyApprovalList(searchText, pageNumber, pageSize, statusFilters = {}) {
    var url = "Admin/GetCompanyApprovalList";
    var params = {
        "SearchText": searchText
        ,"CurrentPageNumber": pageNumber
        ,"PageSize": pageSize 
        ,"LangId":localStorage.getItem("currentLangId")
        ,"BrStatusFilter": (statusFilters.brStatus || []).join(",")
        ,"CompInfoStatusFilter": (statusFilters.compInfoStatus || []).join(",")
        ,"ProdInfoFilter": (statusFilters.prodInfoStatus || []).join(",")
        ,"PigStatusFilter": (statusFilters.pigStatus || []).join(",")
    }; 
    return request.post(url, params)
        .then(res => {
            if (res.data) {
                return res.data;
            } else {
                return res.systemErrorMsg;
            }
        })

}
function GetSupplierList_AdsBasicData() {
    var url = "Admin/GetSupplierListing_AdBasicData";
    var params = {};
    return request.post(url, params)
        .then(res => {
            if (res.data) {
                return res.data;
            } else {
                return res.systemErrorMsg;
            }
        })

}
function SendForgetPasswordByAdmin(query) {
    return request({
        url: 'EMPBackend/SendForgetPasswordByAdmin',
        method: 'post',
        data: query
    });
}
function ResetAccountPassword(query) {
    return request({
        url: 'EMPBackend/ResetAccountPassword',
        method: 'post',
        data: query
    });
}
function SubmitReminderEmail(query){
    return request({
        url: 'EMPBackend/SubmitReminderEmail',
        method: 'post',
        data: query
    });
}

function SubmitReminderEmailAll(query){
    return request({
        url: 'EMPBackend/SubmitReminderEmailAll',
        method: 'post',
        data: query
    });
}

function SendAccountPasswordEmail(query){
    return request({
        url: 'EMPBackend/SendAccountPasswordEmail',
        method: 'post',
        data: query
    });
}
function GetBlacklist(){
    return request.post("admin/getblacklist")
        .then(res => {
            if (res.data) {
                return res.data;
            } else {
                return res.systemErrorMsg;
            }
        })
}

function DeleteBlacklist(RID){
    return request.post(`admin/deleteblacklist?rid=${RID}`)
        .then(res => {
            return res.isSuccessful? true:res.systemErrorMsg
        })

}

function AddBlacklist(visitorId, type){
    return request.post(`admin/addblacklist?visitorId=${visitorId}&type=${type}`)
        .then(res => {
            return res.isSuccessful? true: res.systemErrorMsg
        })
}

function GetMembershipByEmail(email){
    return request.post(`admin/getmembershipbyemail?email=${email}`)
        .then(res=>{
            if(res.data){
                return res.data
            }else{
                return res.systemErrorMsg
            }
        })
}

function InsertAiCompanyResearchQueue(params) {
    return request({
        url:'EMPBackend/InsertAiCompanyResearchQueue',
        method:'post',
        params: params
    });
}

function SubmitAiResearchPreview(params) {
    return request({
        url:'EMPBackend/SubmitAiResearchPreview',
        method:'post',
        params: params
    });
}

/**
 * 获取驳回原因列表接口
 * @returns {Promise} 驳回原因列表数据
 */
async function GetRejectReasons() {
    return await request({
        url: 'EMPBackend/GetRejectReasons',
        method: 'post'
    });
}

/**
 * 按 ApprovalId 获取驳回模板列表
 * @param {number|string} approvalId
 * @returns {Promise}
 */
function GetRejectTemplatesByApprovalId(approvalId) {
    return request({
        url: 'Approval/GetRejectTemplatesByApprovalId',
        method: 'get',
        params: { approvalId },
    });
}

/**
 * 按 ApprovalId 获取送审驳回原因（SP: proc_ApprovalRequest_GetRejectReasonByApprovalId）
 * RejectedReason 已由 udf_GetAliyunRejectLabel 转义。
 * @param {number|string} approvalId
 * @param {string} [resultType] 可选 EntityType 过滤
 */
function GetRejectReasonByApprovalId(approvalId, resultType) {
    const params = { approvalId };
    if (resultType) {
        params.resultType = resultType;
    }
    return request({
        url: 'Approval/GetRejectReasonByApprovalId',
        method: 'get',
        params,
    });
}

function GetAllSysStatusByType(statusType) {
    return request.post(`admin/GetAllSysStatusByType?statusType=${statusType}&langId=${localStorage.getItem("currentLangId")}`)
        .then((res) => res);
}